import Avatar from '@mui/material/Avatar';
import CustomAvtaar from "../assets/borrower-page/avtaar.svg";

function CustomAvtar() {
    return (
        <Avatar
            alt="Avtaar Logo"
            src={CustomAvtaar} // Use curly braces around the variable name
            sx={{ width: 56, height: 56 }}
        />
    );
}

export default CustomAvtar;
